import { Fragment } from 'react';
import { Section } from './Section.jsx';
import { T } from '../T.jsx';

const STEPS = [
  {
    n: 1,
    icon: '✍️',
    glow: 'var(--glow-e)',
    accent: 'var(--accent-e)',
    titleKey: 'ml_step_create_title',
    title: 'Create',
    descKey: 'ml_step_create_desc',
    desc: `Build your presentation using the visual editor or let AI generate a draft
      from your outline. Add media, equations, and interactive elements.`,
  },
  {
    n: 2,
    icon: '\u{1F4FA}',
    glow: 'var(--glow-d)',
    accent: 'var(--accent-d)',
    titleKey: 'ml_step_present_title',
    title: 'Present',
    descKey: 'ml_step_present_desc',
    desc: `Go live with real-time slide sync, audience interaction tools, and AI
      captions. Students follow along on any device.`,
  },
  {
    n: 3,
    icon: '\u{1F4CA}',
    glow: 'var(--glow-i2)',
    accent: 'var(--accent-i2)',
    titleKey: 'ml_step_review_title',
    title: 'Review',
    descKey: 'ml_step_review_desc',
    desc: `AI generates lecture summaries, quiz questions, and engagement analytics.
      Students review and teachers refine for the next session.`,
  },
];

export function Workflow() {
  return (
    <Section>
      <section className="section workflow-section" id="workflow">
        <T k="ml_workflow_label" className="section-label">How It Works</T>
        <T k="ml_workflow_heading" as="h2" className="section-heading fade-in">
          Three Simple Steps
        </T>
        <T k="ml_workflow_intro" as="p" className="section-intro fade-in">
          From idea to impactful lecture in minutes. MyLecture streamlines your entire workflow.
        </T>
        <div className="steps-grid">
          {STEPS.map((step, i) => (
            <Fragment key={step.n}>
              {/* The arrow is a grid item between cards, not part of either. */}
              {i > 0 && <div className="step-connector">&#10132;</div>}
              <div className="step-card fade-in">
                <div className="step-number">{step.n}</div>
                <div className="step-icon" style={{ background: step.glow, color: step.accent }}>
                  {step.icon}
                </div>
                <T k={step.titleKey} as="h3">{step.title}</T>
                <T k={step.descKey} as="p">{step.desc}</T>
              </div>
            </Fragment>
          ))}
        </div>
      </section>
    </Section>
  );
}
